import { authorizedAPI } from '@/config/axios.config';
import { UtilsService } from '@/services/utils/utils.service';
import type { CompanyOnboardingStatus } from '@/types/user.types';

const utils = new UtilsService();

class CompanyOnboardingService {
  getStatus(companyId: string) {
    return utils.handleApiRequest<CompanyOnboardingStatus>(() =>
      authorizedAPI.get(`/company-onboarding/${companyId}/status`),
    );
  }
}

export const companyOnboardingService = new CompanyOnboardingService();

